import { useTranslations } from '@vocab/react';
import { Button } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import translations from '../../../.vocab';
import type { StatefulRecommendedQuestion } from '../../App/state';
import type { DraftCustomQuestion } from '../DraftCustomQuestion/DraftCustomQuestion';

interface AddCustomQuestionProps {
  customQuestions: Array<StatefulRecommendedQuestion | DraftCustomQuestion>;
  addDraftCustomQuestion: () => void;
}

export const AddCustomQuestion: FunctionComponent<AddCustomQuestionProps> = ({
  customQuestions,
  addDraftCustomQuestion,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Button variant="ghost" onClick={addDraftCustomQuestion}>
      {customQuestions.length === 0
        ? t('custom.question.addFirst')
        : t('custom.question.addAnother')}
    </Button>
  );
};
